import employeeApi from '../api/employee';
import moment from 'moment';
import { showErrorMessage } from '../dialogs';

export default {
    populateTimeElements,
    populateBreaks,
    updateTikklokHeader,
    registerTimeLocation,
    registerTime,
    registerBreak,
    registerPause,
    initTikklok,
};

function initTikklok() {
    //Tikklok menu items
    //1. check if the employee chose 'verplaatsing' or 'productie'.
    const store = window.vuexStore;
    const userLocation = store.getters['currentUser/getUserLocation'];
    if (!userLocation || userLocation.length === 0) {
        store.commit('currentUser/hideActions', { root: true });
    } else {
        store.commit('currentUser/initWorkDayBreakState', { root: true });
        store.commit('currentUser/initSmokingBreakAction', { root: true });
        store.commit('currentUser/hideTikklokBreakTitle', { root: true });
        store.commit('currentUser/showActions', { root: true });
    }

    //Check the correct state since loading this page
    updateTikklokHeader();
}

function populateTimeElements() {
    const store = window.vuexStore;
    employeeApi
        .listTimeregistrations()
        .then((response) => {
            const userLocation = store.getters['currentUser/getUserLocation'];
            if (userLocation == 'Productie' || userLocation == 'Verplaatsing') {
                const timeRegistrations = response.data.data;
                store.commit(
                    'currentUser/setTimeRegistrations',
                    timeRegistrations,
                    { root: true }
                );
            }
        })
        .catch(() => {
            showErrorMessage('Onbekende fout bij ophalen van tijdregistraties');
        });
}

function populateBreaks() {
    const store = window.vuexStore;

    employeeApi
        .listBreaks()
        .then((response) => {
            const breakData = response.data.data;

            breakData.totalBreaks = moment.duration(
                breakData.totalBreaks,
                'second'
            );
            breakData.totalBreaks =
                breakData.totalBreaks.hours() +
                ':' +
                breakData.totalBreaks.minutes() +
                ':' +
                breakData.totalBreaks.seconds();
            store.commit(
                'currentUser/setTotalSmokeTime',
                breakData.totalBreaks,
                { root: true }
            );

            // Check if start break/ end break
            if (
                breakData.breaks.length >= 1 &&
                breakData.breaks[breakData.breaks.length - 1].end === null
            ) {
                // Show stop button
                store.commit('currentUser/showStopSmokingBreakAction', {
                    root: true,
                });
                store.commit('currentUser/showTikklokBreakTitle', {
                    root: true,
                });
                store.commit(
                    'currentUser/setTikklokBreakTitle',
                    ' - Rookpauze is bezig',
                    { root: true }
                );
            } else {
                // Show Start button
                store.commit('currentUser/showStartSmokingBreakAction', {
                    root: true,
                });
                store.commit('currentUser/hideTikklokBreakTitle', {
                    root: true,
                });
            }
        })
        .catch(() => {
            showErrorMessage('Onbekende fout bij ophalen van rookpauzes');
        });
}

function updateTikklokHeader() {
    employeeApi
        .listBreaksAndTimeregistrations()
        .then((response) => {
            const timeData = response.data.data;
            populateTikKlokHeader(timeData.count);
            if (
                timeData.breaks.length >= 1 &&
                timeData.breaks[timeData.breaks.length - 1].end === null
            ) {
                showStopRookPauze();
            } else {
                showStartRookPauze();
            }
        })
        .catch(() => {
            showErrorMessage('Onbekende fout bij updaten van tikklokheader');
        });
}

function populateTikKlokHeader(count) {
    const store = window.vuexStore;

    if (store.getters['currentUser/getUserLocation'] == 'Verplaatsing') {
        switch (count) {
            case 0:
                showStartWerkdag();
                break;
            case 1:
                showStopWerkdag();
                break;
            case 4:
                store.commit('currentUser/hideActions', { root: true });
                break;
            default:
        }
    } else {
        switch (count) {
            case 0:
                showStartWerkdag();
                break;
            case 1:
                showStartPauze();
                break;
            case 2:
                showStopPauze();
                break;
            case 3:
                showStopWerkdag();
                break;
            case 4:
                store.commit('currentUser/hideActions', { root: true });
                break;
            default:
        }
    }
}

function showStartWerkdag() {
    const store = window.vuexStore;
    store.commit('currentUser/showStartWorkDayState');
    store.commit('currentUser/setTikklokTitle', 'Werkdag nog niet gestart', {
        root: true,
    });
}

function showStopWerkdag() {
    const store = window.vuexStore;
    store.commit('currentUser/showStopWorkDayState');
    store.commit('currentUser/setTikklokTitle', 'Werkdag is bezig', {
        root: true,
    });
}

function showStartPauze() {
    const store = window.vuexStore;
    store.commit('currentUser/showStartBreakState');
    store.commit('currentUser/setTikklokTitle', 'Werkdag is bezig', {
        root: true,
    });
}

function showStopPauze() {
    const store = window.vuexStore;
    store.commit('currentUser/showStopBreakState');
    store.commit('currentUser/setTikklokTitle', 'Pauze is bezig', {
        root: true,
    });
}

function showStartRookPauze() {
    const store = window.vuexStore;
    store.commit('currentUser/showStartSmokingBreakAction', { root: true });
    store.commit('currentUser/hideTikklokBreakTitle', { root: true });
}

function showStopRookPauze() {
    const store = window.vuexStore;
    store.commit('currentUser/showStopSmokingBreakAction', { root: true });
    store.commit('currentUser/showTikklokBreakTitle', { root: true });
    store.commit('currentUser/setTikklokBreakTitle', ' - Rookpauze is bezig', {
        root: true,
    });
}

function registerTimeLocation(location) {
    const store = window.vuexStore;
    employeeApi
        .registerTimeLocation(location)
        .then(() => {
            store.commit('currentUser/setUserLocation', location, {
                root: true,
            });
            window.newVueApp.$router.go(); //change tikklok menu button
        })
        .catch(() => {
            showErrorMessage('Onbekende fout bij opslaan van locatie');
        });
}

function registerTime(callback) {
    const store = window.vuexStore;

    const location = store.getters['currentUser/getUserLocation'];
    if (!location) {
        return showErrorMessage('Er is geen locatie gekozen');
    }

    const employeeId = store.getters['currentUser/getUserId'];

    // Make sure workday exists here
    employeeApi
        .registerTimeLocation(location, employeeId)
        .then(() => {
            employeeApi
                .countTimeregistrations(location, employeeId)
                .then((response) => {
                    const count = response.data.data.count;
                    if (
                        (location == 'Productie' && count < 4) ||
                        (location == 'Verplaatsing' && count < 1)
                    ) {
                        employeeApi
                            .registerTime(location, employeeId)
                            .then(() => {
                                callback();
                                updateTikklokHeader();
                                populateTimeElements();
                            })
                            .catch(() => {
                                showErrorMessage(
                                    'Onbekende fout bij opslaan van tijd'
                                );
                            });
                    } else if (location == 'Verplaatsing' && count < 2) {
                        registerPause(() => {
                            callback();
                            updateTikklokHeader();
                            populateTimeElements();
                        });
                    } else {
                        showErrorMessage(
                            'Verkeerde locatie (' +
                                location +
                                ') of tiktelling (' +
                                count +
                                ')'
                        );
                    }
                })
                .catch(() => {
                    showErrorMessage('Onbekende fout bij tellen van tijden');
                });
        })
        .catch(() => {
            showErrorMessage('Onbekende fout bij opslaan van de locatie');
        });
}

function registerBreak(callback) {
    employeeApi
        .registerBreak()
        .then(() => {
            callback();
            populateBreaks();
        })
        .catch(() => {
            showErrorMessage('Onbekende fout bij registeren van rookpauze');
        });
}

function registerPause(callback) {
    employeeApi
        .registerTimePause(30)
        .then((response) => {
            const notification = response.data.data.notification;
            if (notification && notification !== true) {
                showErrorMessage(notification);
            } else {
                callback();
                updateTikklokHeader();
            }
        })
        .catch(() => {
            showErrorMessage('Onbekende fout bij registreren van pauze');
        });
}
